/**
 * codec.ts — snapshot encode/decode behind one interface.
 *
 * v0 is JSON (this file). v1 is a little-endian DataView codec (M6) that plugs in
 * behind the same interface, so nothing else in the game learns about the wire
 * format. Quantization, when it arrives, happens here and only here.
 */
/** Codec v0: plain JSON. Readable in devtools; the debug default until M6. */
export const jsonCodec = {
    version: 0,
    name: 'json',
    encode: (snapshot) => JSON.stringify(snapshot),
    decode: (wire) => {
        if (typeof wire !== 'string') {
            throw new TypeError('jsonCodec.decode expected a string');
        }
        return JSON.parse(wire);
    },
};
/** The codec both ends use. M6 swaps this for the binary one behind a debug flag. */
export const activeCodec = jsonCodec;
//# sourceMappingURL=codec.js.map